// extracted by css-extract-rspack-plugin
export default {"header":"Header-module__header__bsY1n","avatar":"Header-module__avatar__wo9ij","title":"Header-module__title__EpJLU","smallTitle":"Header-module__smallTitle__jWtz5"};